<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">默认值</nz-form-label>
  <nz-form-control>
    <input nz-input #nameInput="ngModel" name="value" type="text" [(ngModel)]="config.value" />
  </nz-form-control>
</nz-form-item>
